import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import TyronPasswordGate from './TyronPasswordGate';
import TyronPortfolio from './TyronPortfolio';
import { TyronPrivacy, TyronTerms, TyronDisclaimer, TyronAIPolicy, TyronDPA } from './TyronLegalPages';

const API = process.env.REACT_APP_BACKEND_URL || '';

const TyronApp = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Verify any existing preview token against the backend (SEC-005)
    const token = sessionStorage.getItem('tyronToken');
    if (!token) return;
    fetch(`${API}/api/tyron/verify`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? setIsAuthenticated(true) : sessionStorage.removeItem('tyronToken')))
      .catch(() => {});
  }, []);

  if (!isAuthenticated) {
    return <TyronPasswordGate onAuthenticated={() => setIsAuthenticated(true)} />;
  }

  return (
    <Routes>
      <Route path="/" element={<TyronPortfolio />} />
      <Route path="/privacy" element={<TyronPrivacy />} />
      <Route path="/terms" element={<TyronTerms />} />
      <Route path="/disclaimer" element={<TyronDisclaimer />} />
      <Route path="/ai-policy" element={<TyronAIPolicy />} />
      <Route path="/dpa" element={<TyronDPA />} />
    </Routes>
  );
};

export default TyronApp;
